/**
 * Constantes centralizadas para RAE Project Management
 */
import { TaskStatus } from '../types';

// ==================== STORAGE KEYS ====================
export const STORAGE_KEYS = {
  AUTH_USER: 'rae_pm_user',
  THEME: 'rae_pm_theme',
  PROFILE_CACHE: 'rae_pm_profile',
  ACTIVE_PROJECT: 'rae_pm_active_project',
  CAPACITY_PLAN: 'rae_pm_capacity_plan',
} as const;

// ==================== FILE PATTERNS ====================
export const FILE_PATTERNS = {
  IMAGE: /\.(png|jpg|jpeg|gif|webp|bmp|svg)$/i,
  PDF: /\.pdf$/i,
} as const;

// ==================== FILE VALIDATION ====================
export const FILE_SIZE_LIMITS = {
  IMAGE: 5 * 1024 * 1024,    // 5 MB
  DOCUMENT: 10 * 1024 * 1024, // 10 MB
} as const;

export const ALLOWED_MIME_TYPES = {
  IMAGE: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp', 'image/svg+xml'] as string[],
  DOCUMENT: ['application/pdf'] as string[],
} as const;

// ==================== GANTT CHART DIMENSIONS ====================
export const GANTT_DIMENSIONS = {
  DAY_WIDTH: 28,
  ROW_HEIGHT: 32,
  GROUP_ROW_HEIGHT: 28,
  HEADER_HEIGHT: 48,
} as const;

export const GANTT_PDF_DIMENSIONS = {
  MARGIN: 10,
  TASK_LIST_WIDTH: 90,
  TASK_ROW_HEIGHT: 6,
  GROUP_ROW_HEIGHT: 5.5,
  MONTH_ROW_HEIGHT: 8,
  DAY_ROW_HEIGHT: 7,
  ZONE_HEADER_HEIGHT: 12,
  PAGE_HEIGHT: 297,
  COVER_WIDTH: 420,
  MAX_DAY_WIDTH: 5,
  MIN_DAY_WIDTH: 2,
} as const;

// ==================== CALENDAR / SCHEDULE ====================
export const WEEKDAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;

// ==================== TASK STATUS SORT ORDER ====================
export const TASK_STATUS_SORT_ORDER: Record<TaskStatus, number> = {
  ISSUES: 0,
  IN_REVIEW: 1,
  IN_PROGRESS: 2,
  PAUSED: 3,
  STARTED: 4,
  ASSIGNED: 5,
  FINISHED: 6,
};
